module.exports = __webpack_public_path__ + "static/ayfon-da2a7ca2705ea6275da94b105e825d76.svg";